import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { ModalErrorComponent } from './modal-error/modal-error.component';
import { ModalInfoComponent } from './modal-info/modal-info.component';
import { ModalSearchUserComponent } from './modal-search-user/modal-search-user.component';
import { ModalSearchOfferComponent } from './modal-search-offer/modal-search-offer.component';
import { ModalSaveOfferComponent } from './modal-save-offer/modal-save-offer.component';
import { OfferStatusComponent } from './offer-status/offer-status.component';
import { ModalSetStatusComponent } from './modal-set-status/modal-set-status.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient]
      }
    }),
  ],
  exports: [
    ModalErrorComponent,
    ModalInfoComponent,
    ModalSearchUserComponent,
    ModalSearchOfferComponent,
    ModalSetStatusComponent,
    ModalSaveOfferComponent,
    OfferStatusComponent
  ],
  declarations: [
    ModalErrorComponent,
    ModalInfoComponent,
    ModalSearchUserComponent,
    ModalSearchOfferComponent,
    ModalSetStatusComponent,
    ModalSaveOfferComponent,
    OfferStatusComponent
  ],
  providers: [

  ],
  entryComponents: [ModalErrorComponent,
    ModalInfoComponent,
    ModalSearchUserComponent,
    ModalSearchOfferComponent,
    ModalSetStatusComponent,
    ModalSaveOfferComponent,
    OfferStatusComponent]
})
export class SectionsModule { }

export function httpTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/locale/', '.json');
}
